<script setup>
import { ref, watch } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
    modelValue: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        required: false,
    },
    labelClass: {
        type: String,
        default: '',
    },
    required: {
        type: Boolean,
        required: false,
    },
    options: {
        type: Array,
        default: () => [],
    },
    optionValue: {
        type: String,
        default: 'value',
    },
    optionLabel: {
        type: String,
        default: 'label',
    },
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue']);

/** Styling */
const passThrough = {
    root: 'tw-flex',
    button: ({ context }) => ({
        class: [
            'tw-flex-1 tw-text-[20px] tw-font-neue-kabel-bold tw-rounded-full tw-h-[47px]',
            context.active ? '!tw-bg-primary' : '!tw-text-secondary !tw-border-secondary',
        ],
    }),
    label: 'tw-pt-[4px]',
};

const selected = ref(props.modelValue);
watch(selected, (newVal) => {
    emit('update:modelValue', newVal);
});
</script>

<template>
    <div>
        <label
            v-if="props.label"
            for=""
            class="!tw-text-[20px] tw-block tw-mb-8"
            :class="props.labelClass"
        >
            {{ props.label }}
        </label>

        <SelectButton
            v-model="selected"
            :options="props.options"
            :option-label="props.optionLabel"
            :option-value="props.optionValue"
            :allow-empty="false"
            :pt="passThrough"
        />
    </div>
</template>
